import apiClient from '@/services/axios'
import { notification } from 'ant-design-vue'

const wheelApiUrl = process.env.VUE_APP_WHEEL_API_URL

const getSectorTypeOptions = async (wheelId) => {
  try {
    const url = `${wheelApiUrl}/admin/logs/${wheelId}/get-options`
    const response = await apiClient.get(url)
    if (response?.data?.status) {
      return response.data.sector_types
    }
    return null
  } catch (e) {
    notification.error({
      message: e?.message ? e.message : 'Error',
    })
  }
}

export { getSectorTypeOptions }
